module.exports = __webpack_public_path__ + "static/media/christian-dior-homme-intese-big.33a4c2ac.png";